import { FaFacebookF, FaPinterestP, FaInstagram, FaLinkedinIn, FaYoutube, FaTiktok } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
export const BASE_CLASS_NAME_FOLLOW = 'social__list-item social__list-item--follow';
export const PORTRAIT = 'portrait';
export const LANDSCAPE = 'landscape';
export const SOCIAL_NETWORKS = {
  facebook: {
    name: 'Facebook',
    className: 'facebook',
    Icon: FaFacebookF,
    spanClassName: 'hidden'
  },
  twitter: {
    name: 'Twitter',
    className: 'twitter',
    Icon: FaXTwitter,
    spanClassName: 'hidden'
  },
  pinterest: {
    name: 'Pinterest',
    className: 'pinterest',
    Icon: FaPinterestP,
    spanClassName: 'hidden'
  },
  instagram: {
    name: 'Instagram',
    className: 'instagram',
    Icon: FaInstagram,
    spanClassName: 'hidden'
  },
  linkedin: {
    name: 'Linkedin',
    className: 'linkedin',
    Icon: FaLinkedinIn,
    spanClassName: 'hidden'
  },
  youtube: {
    name: 'YouTube',
    className: 'youtube',
    Icon: FaYoutube,
    spanClassName: 'hidden'
  },
  tiktok: {
    name: 'TikTok',
    className: 'tiktok',
    Icon: FaTiktok,
    spanClassName: 'hidden'
  }
};
//# sourceMappingURL=sf.config.js.map